export function rotateLeft<T>(arr: (T | undefined)[]): (T | undefined)[] {
  const first = arr.shift();

  arr.push(first);

  return arr;
}

export default rotateLeft;
